<template>
  <v-container>

    <v-row justify="center" v-if="$store.getters.user.data.covered !== null && isNextToPay()">
      <v-col cols="12" md="7">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            {{ $store.getters.user.data.covered ? $t('billing.titles.next-payment') : $t('billing.titles.pending-payment') }}
          </v-card-title>
          <v-card-text class="pt-3">
            <p class="body-1 font-weight-regular">
              {{ $store.getters.user.data.covered ? $t('billing.messages.next-payment') : $t('billing.messages.pending-payment') }}
              <b>{{ $store.getters.user.data.covered ? nextPaymentDate : expirationDate }}</b>.
              {{ $store.getters.user.data.covered ? $t('billing.messages.renew-next-suscription') : $t('billing.messages.renew-suscription') }}
            </p>
            <v-divider class="my-5" />
            <v-row>
              <v-col cols="12" class="text-center">
                <span class="subtitle-1 font-weight-medium">{{ $t('billing.titles.pay-information') }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="text-right body-1 font-weight-regular py-0">
                {{ $t('billing.information.value') }}:
              </v-col>
              <v-col cols="6" class="text-left body-1 font-weight-medium py-0">
                <v-icon class="mx-n1">attach_money</v-icon>
                {{ value }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="text-right body-1 font-weight-regular py-1">
                {{ $t('billing.information.plan') }}:
              </v-col>
              <v-col cols="6" class="text-left body-1 font-weight-medium py-1">
                {{ plan }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="text-right body-1 font-weight-regular py-1">
                {{ $t('billing.information.coverage-date') }}:
              </v-col>
              <v-col cols="6" class="text-left body-1 font-weight-medium py-1">
                {{ nextExpirationDate }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-center">
                <v-btn color="primary" @click="makePayment">
                  <v-icon class="mr-1">payment</v-icon>
                  {{ $t('billing.buttons.pay') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row
      justify="center">
      <v-col cols="12" md="7">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            {{ $t('billing.titles.main') }}
          </v-card-title>
          <v-card-text>
            <v-simple-table
              fixed-header
              v-if="invoices.length > 0"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>{{$t('billing.table.headers.reference')}}</th>
                    <th class="text-right">{{$t('billing.table.headers.value')}}</th>
                    <th class="text-center">{{$t('billing.table.headers.date')}}</th>
                    <th class="text-center">{{$t('billing.table.headers.coverage')}}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="invoice in invoices" :key="invoice.id">
                    <td>{{ invoice.reference }}</td>
                    <td class="text-right">
                      <v-icon class="mx-n1">attach_money</v-icon>
                      {{ paymentValue(invoice.payment.value) }}
                    </td>
                    <td class="text-center">{{ paymentDate(invoice.payment.created_at) }}</td>
                    <td class="text-center">{{ paymentDate(invoice.payment.coverage_date) }}</td>
                    <td class="text-right">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn icon v-on="on" @click="loadPaymentDetails(invoice)">
                            <v-icon>search</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('billing.tooltips.details') }}</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-row v-else justify="center">
              <v-col cols="12" class="text-center mt-3">
                <span>{{ $t('billing.messages.no-results') }}</span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog persistent v-model="dialog_payment" max-width="500">
        <v-card class="text-center">
            <v-card-title class="title font-weight-regular">
              <v-col cols="12" class="text-center">
              {{ $t('billing.messages.wait') }}
              </v-col>
            </v-card-title>
            <v-card-text class="pt-8 pb-12">
              <v-alert type="error" dismissible v-if="error_payment" class="mt-5">{{ error_payment }}</v-alert>
              <v-progress-circular
                v-else
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-if="payment_detail" v-model="dialog_detail" max-width="600">
        <payment-detail :reference="payment_detail.reference" />
    </v-dialog>

    <v-overlay :value="!loaded" opacity="1" color="white" light absolute>
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<style lang="scss">
// .remove-border.v-text-field>.v-input__control>.v-input__slot:after {
//   border-style: none;
// }
</style>

<script>
import { getInvoices, createPayment, createPreference } from '@/store/module/billing'
import { sandboxMercadopago } from '@/mercadopagoConfig'
import PaymentDetailComponent from '@/views/customer/Payment'

export default {
  components: {
    'payment-detail': PaymentDetailComponent
  },
  data() {
    return {
      days_notifications: 5,
      error_payment: null,
      dialog_payment: false,
      loaded: false,
      loading: false,
      notification: {
        color: 'gree',
        show: false,
        message: ''
      },
      invoices: [],
      expiration_date: '',
      next_expiration_date: '',
      value: 0,
      plan: '',
      currency_options: {
        currency: null,
        precision: 0,
        valueAsInteger: true,
        allowNegative: false,
        distractionFree: {
          hideNegligibleDecimalDigits: false,
          hideCurrencySymbol: false,
          hideGroupingSymbol: false
        }
      },
      payment_detail: null,
      dialog_detail: false
    }
  },
  created() {
    this.getPlan()
  },
  mounted() {
    this.getInvoices()
  },
  computed: {
    nextExpirationDate() {
      let date = new Date(this.$store.getters.user.data.next_payment)
      let next_expiration = new Date(date.setMonth(date.getMonth() + this.$store.getters.user.data.plan.cycle))
      return this.getFormatedDate(next_expiration)
    },
    nextPaymentDate() {
      return this.getFormatedDate(this.$store.getters.user.data.next_payment)
    },
    expirationDate() {
      let date = new Date(this.$store.getters.user.data.last_payment)
      let last_payment = new Date(date.setMonth(date.getMonth() + this.$store.getters.user.data.plan.cycle))
      return this.getFormatedDate(last_payment)
    }
  },
  methods: {
    isNextToPay() {
      let today = new Date()
      let date_notification = new Date(this.$store.getters.user.data.next_payment)
      date_notification.setDate(date_notification.getDate() - this.days_notifications)

      return today >= date_notification
    },
    getNextExpirationDate() {
      let date = new Date(this.$store.getters.user.data.next_payment)
      return new Date(date.setMonth(date.getMonth() + this.$store.getters.user.data.plan.cycle))
    },
    paymentValue(value) {
      return parseInt(value).toLocaleString('es-ES')
    },
    paymentDate(created_at) {
      let date = new Date(created_at.seconds * 1000)
      return this.getFormatedDate(date)
    },
    getFormatedDate(date) {
      let month_name = date.toLocaleString('es-es', { month: "long" })
      let day = "0" + date.getDate()
      return day.substr(-2) + ' de ' + month_name + ' ' + date.getFullYear()
    },
    getPlan() {
      let price = this.$store.getters.user.data.plan.price.replace('.', '')
      price = parseInt(price).toLocaleString('es-ES')
      this.plan = this.$store.getters.user.data.plan.name
      this.value = price
    },
    getInvoices() {
      getInvoices()
      .then(invoices => {
        this.invoices = invoices
        this.loaded = true
      })
      .catch(error => {
        console.log('ERROR:', error.messages)
      })
    },
    makePayment() {
      this.error_payment = null
      this.dialog_payment = true
      let reference = Math.random().toString(36).substr(2, 9).toUpperCase()
      let price = this.$store.getters.user.data.plan.price.replace('.', '')
      price = parseInt(price)
      createPayment(this.$store.getters.user.data.plan, price, reference, this.getNextExpirationDate())
      .then(() => {
        createPreference(this.$store.getters.user.data, price, reference, this.$t('billing.titles.preference', { name: this.plan }))
        .then(response => {
          if (response.status === 201) {
            let redirect_url = sandboxMercadopago ? response.data.sandbox_init_point : response.data.init_point
            window.location = redirect_url
          }
        })
        .catch(error => {
          console.log('ERROR:', error.message)
        })
      })
      .catch(error => {
        this.error_payment = error.message
      })
    },
    loadPaymentDetails(invoice) {
      this.payment_detail = invoice
      this.dialog_detail = true

    }
  }
}
</script>
